import { Color, CornerType, CesiumTerrainProvider } from "cesium";
import { Tileset, GeoJSON, PointCloud, TMS, Terrain } from '../utils/layer-types.js'

export const arcgisBaseURL = undefined;
//const arcgisBaseURL = "https://192.168.70.39:6443";
export const applicationUrl = "https://app.csds.om/madayn";
// export const terrainBaseUrl = "http://localhost:8087";

export const _terrain = {
    id: 0,
    name: Terrain,
    label: "Terrain providers",
    elements: [
      {
        id: 1103,
        name: "barka_dem",
        label: "Barka DEM",
        visible: true,
        init: async () =>
          await CesiumTerrainProvider.fromUrl(
            applicationUrl + "/terrain/Barka_DEM"
          ),
      },
    ],
  };

  
export const _layers = [
    {
        id: 1100,
        name: "Ortho over DEM",
        label: "Ortho over DEM",
        visible: false,
        type: TMS,
        options: {
          data: applicationUrl + "/terrain/barka",
          fileExtension: "png",
        },
    },
    {
        id: 1000,
        name: 'Texture mesh',
        label: 'Texture mesh',
        visible: false,
        type: Tileset,
        options: {
            data: "./texture-mesh/tileset.json"
        }
    },
    // {
    //     id: 1010,
    //     name: 'Generated mesh',
    //     visible: true,
    //     type: "Tileset",
    //     options: {
    //         debugShowBoundingVolume: true,
    //         maximumScreenSpaceError: 1000,
    //         data: "./mesh-tileset/tileset.json"
    //     }
    // },
    {
        id: 1001,
        name: 'Point cloud (RGB)',
        label: 'Point cloud (RGB)',
        visible: false,
        type: PointCloud,
        options: {
            data: "./points-tileset/tileset.json",
        }
    },
    {
        id: 1002,
        name: 'Point cloud (NDVI)',
        label: 'Point cloud (NDVI)',
        visible: false,
        type: PointCloud,
        options: {
            data: "./points-tileset/tileset.json",
            style: {
                color : {
                    conditions : [
                        ['${CLASSIFICATION} >= 14', 'vec4(1, (28-${CLASSIFICATION})/14, (28-${CLASSIFICATION})/14, 1)'],
                        ['${CLASSIFICATION} >= 0', 'vec4(${CLASSIFICATION/13}, ${CLASSIFICATION/13}, 1, 1)'],
                        ['true', 'color("orange")']
                    ]
                },
                show : '(${CLASSIFICATION} >= 0) && (${CLASSIFICATION} <= 28)'
              }
        }
    },
    {
        id: 1004,
        name: 'Clustered objects',
        label: 'Clustered objects',
        visible: false,
        type: PointCloud,
        options: {
            data: "./clustered-objects/tileset.json",
            style: {
                defines : {
                    colored : "${INTENSITY} < 250"
                },
                color : {
                    conditions : [
                        ['${colored}', "hsl(${INTENSITY} /250, 0.7, 0.5)"],
                        ['true', "color('white')"]
                    ]
                }
            }
        }
    },
    {
        id: 1005,
        name: 'PCA analysis - verticality',
        label: 'PCA analysis - verticality',
        visible: true,
        type: PointCloud,
        options: {
            data: "./verticality/tileset.json",
            style: {
                color : {
                    conditions : [
                        ['${CLASSIFICATION} >= 15', 'vec4(1, (30-${CLASSIFICATION})/15, (30-${CLASSIFICATION})/15, 1)'],
                        ['${CLASSIFICATION} >= 0', 'vec4(${CLASSIFICATION/14}, ${CLASSIFICATION/14}, 1, 1)'],
                        ['true', 'color("orange")']
                    ]
                },
                show : '(${CLASSIFICATION} >= 0) && (${CLASSIFICATION} <= 30)'
              }
        }
    },
    {
        id: 3,
        name: 'Parcels',
        label: 'Parcels',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./json/parcels.geojson",     
            // stroke: Color.RED,               
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline
                    
                    var entity = entities[i];
                    // console.log(entity);
                    // entity.wall = {
                    //     positions: entity.polyline.positions,
                    //     //minimumHeights: [100.0, 100.0],
                    //     material: Color.GREEN,
                    //     outline: true,
                    // };
                    entity.corridor = {
                        positions: entity.polyline.positions,
                        extrudedHeight: 30.0,
                        width: 0.2,
                        height: 40,
                        cornerType: CornerType.MITERED,
                        material: Color.GREEN,
                        outline: true, // height required for outlines to display
                      };
                    //entity.corridor.heightReference = HeightReference.CLAMP_TO_3D_TILE;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 4,
        name: 'Buildings',
        label: 'Buildings',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./json/buildings.geojson",     
            stroke: Color.BLACK,        
            fill: Color.LIGHTBLUE,   
            
            //clampToGround:true,    
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline
                    
                    var entity = entities[i];
                    entity.polygon.extrudedHeight = 30;
                    //entity.polygon.height = 40;
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
];